import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, AbstractControl } from '@angular/forms';

import { Unidade } from '../../../models/unidade';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/combineLatest';
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { Util } from '../../shared/util';
import { FaseService } from '../fase.service';
import { UnidadeService } from '../../shared/services/unidade.service';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { IndicadorService } from '../../../services/indicador.service';
import { Indicador } from '../../../models/Indicador';
import { forEach } from '@angular/router/src/utils/collection';
import { Municipio } from '../../../models/municipio';

@Component({
  templateUrl: './cadastrar-editar-fase.component.html',
})
export class CadastrarEditarFaseComponent extends WebPage implements OnInit {

  display = false;
  editaUnidade = false;
  idFase;
  hasCandidatosOrEditaisCredenciamentoCadastrados = false;
  uploadUrl: string;
  unidades: Unidade[] = [] as Unidade[];
  arquivosToRemove = new FormArray([]);
  //Cidades
  displayCidade = false;
  tituloCidade = 'Adicionar Cidade';
  unidadesCidade: Unidade[] = [] as Unidade[];
  cidades: Municipio[] = [] as Municipio[];
  cidadesModal: Municipio[] = [] as Municipio[];

  //Categoria
  displayCategoria = false;
  tituloCategoria = 'Adicionar Categoria';
  unidadesCategoria: Unidade[] = [] as Unidade[];
  cidadesCategoria: Municipio[] = [] as Municipio[];
  categorias: Indicador[] = [] as Indicador[];
  categoriasModal: Indicador[] = [] as Indicador[];

  get arquivos() { return this.form.get('arquivos') as FormArray; }
  get nroVagasTotal() { return this.form.get('nroVagasTotal'); }
  get unidadesSelecionadas() { return this.form.get('unidadesSelecionadas') as FormArray; }

  get nroVagasTotalCidades() { return this.form.get('nroVagasTotalCidades'); }
  get cidadesSelecionadas() { return this.form.get('cidadesSelecionadas') as FormArray; }

  get nroVagasTotalCategorias() { return this.form.get('nroVagasTotalCategorias'); }
  get categoriasSelecionadas() { return this.form.get('categoriasSelecionadas') as FormArray; }

  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router, private route: ActivatedRoute,
    private confirmationService: ConfirmationService, messageService: MessageService,
    private faseService: FaseService,
    private unidadeService: UnidadeService,
    private arquivoService: ArquivoService,
    private indicadorService: IndicadorService
  ) {
    super(messageService);

    this.form = this.fb.group({
      idFase: [],
      nroFase: ['', Validators.required],
      nomeFase: ['', Validators.required],
      condicoes: [null, Validators.required],
      descricaoEditalVagas: ['', Validators.required],
      nroVagasTotal: [0],
      nroVagasTotalCidades: [0],
      nroVagasTotalCategorias: [0],
      arquivos: new FormArray([]),
      unidadesSelecionadas: new FormArray([]),
      cidadesSelecionadas: new FormArray([]),
      categoriasSelecionadas: new FormArray([])
    });

    this.uploadUrl = this.arquivoService.uploadUrl + 'editalFase';

    this.route.paramMap.subscribe(params => {
      if (params.has('idFase')) {
        this.idFase = params.get('idFase');
      }
    });
  }

  ngOnInit() {
    this.carregarMunicipios();
    this.carregarUnidades();
    this.carregarIndicadores();

    if (!Util.isNullOrEmptyOrUndefined(this.idFase)) {
      this.isLoading = true;
      this.faseService.getFull(this.idFase)
        .finally(() => this.isLoading = false)
        .subscribe(
          fase => {
            this.form.setValue({
              idFase: fase.idFase,
              nroFase: fase.nroFase,
              nomeFase: fase.nomeFase,
              condicoes: fase.condicoes,
              descricaoEditalVagas: fase.descricaoEditalVagas,
              nroVagasTotal: 0,
              nroVagasTotalCidades: 0,
              nroVagasTotalCategorias: 0,
              arquivos: [],
              unidadesSelecionadas: [],
              cidadesSelecionadas: [],
              categoriasSelecionadas: []
            });

            fase.arquivosMeio.forEach(arquivoMeio =>
              this.adicionaArquivo(arquivoMeio.idArquivo, arquivoMeio.arquivo.nome, true)
            );

            fase.faseUnidades.forEach(faseUnidade => {
              const unidade = faseUnidade.unidade;
              this.adicionaOuEditaUnidade(
                faseUnidade.idUnidade,
                unidade.tipologia + ' - ' + unidade.nomeUnidade + '/' + unidade.uf.siglaUf,
                faseUnidade.inicioInscricoes,
                faseUnidade.encerramentoInscricoes,
                faseUnidade.nroVagas,
                faseUnidade.idFaseUnidade
              );
            });
            fase.faseUnidadeMunicipios.forEach(faseUnidadeMunicipio => {
              const unidade = faseUnidadeMunicipio.unidade;
              const municipio = faseUnidadeMunicipio.municipio;
              console.log(municipio);
              this.adicionaOuEditaCidade(
                unidade.idUnidade,
                unidade.tipologia + ' - ' + unidade.nomeUnidade + '/' + unidade.uf.siglaUf,
                municipio.idMunicipio,
                municipio.nomeCidade,
                faseUnidadeMunicipio.numVagas,
                faseUnidadeMunicipio.idFaseUnidade
              );
            });
            fase.faseUnidadeCategorias.forEach(faseUnidadeCategoria => {
              const unidade = faseUnidadeCategoria.unidade;
              const municipio = faseUnidadeCategoria.municipio;
              const categoria = faseUnidadeCategoria.categoria;
              //console.log(faseUnidadeCategoria);
              this.adicionaOuEditaCategoria(
                unidade.idUnidade,
                unidade.tipologia + ' - ' + unidade.nomeUnidade + '/' + unidade.uf.siglaUf,
                municipio.idMunicipio,
                municipio.nomeCidade,
                categoria.idIndicador,
                categoria.titulo,
                faseUnidadeCategoria.qtdVagas,
                faseUnidadeCategoria.idFaseUnidade
              );
            });
            try{
              this.hasCandidatosOrEditaisCredenciamentoCadastrados =
                (fase.candidatos.length !== 0 || fase.editaisCredenciamento.length !== 0);
            }catch(ex){

            }
          },
          error => this.gerenciaErro(error)
        );
    }
  }

  carregarUnidades() {
    this.isLoading = true;
    this.unidadeService.getUnidades()
      .finally(() => this.isLoading = false)
      .subscribe(
        unidades => this.unidades = unidades,
        error => this.gerenciaErro(error)
      );
  }
  carregarIndicadores() {
    this.isLoading = true;
    this.indicadorService.getByTipoIndicador()
      .finally(() => this.isLoading = false)
      .subscribe(
        indicadores => this.categoriasModal = indicadores,
        error => this.gerenciaErro(error)
      );
  }
  carregarMunicipios() {
    this.isLoading = true;
    this.unidadeService.getListaMunicipioByIdUf('5a11e0ad-6d56-4e01-94ef-7be2162a7f59')
      .finally(() => this.isLoading = false)
      .subscribe(
        cidades => this.cidadesModal = cidades,
        error => this.gerenciaErro(error)
      );
  }

  // ------
  // Arquivos
  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld
    });
    this.arquivos.push(arquivoFormGroup);
  }

  removeArquivo(arquivo: AbstractControl) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);
  }

  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    this.isLoading = true;
    const combined = arquivos.map(a => this.arquivoService.removeArquivo(a.value.idArquivo));
    Observable.combineLatest(combined)
      .finally(() => this.isLoading = false)
      .subscribe(
        () => {},
        error => this.gerenciaErro(error)
      );
  }

  uploadError(mensagem) {
    this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: mensagem });
    this.isLoading = false;
  }
  // Arquivo
  // ------

  // ------
  // Unidade
  mostrarDialog() {
    this.display = true;
  }

  enviaUnidade(unidadeSelecionada: HTMLSelectElement, nroVagas: HTMLInputElement, inicioInscricoes, encerramentoInscricoes) {
    if (!this.validaUnidade(unidadeSelecionada.value, nroVagas.value, inicioInscricoes.value, encerramentoInscricoes.value)) {
      return;
    }

    this.adicionaOuEditaUnidade(
      unidadeSelecionada.value,
      unidadeSelecionada[unidadeSelecionada.selectedIndex].innerHTML,
      inicioInscricoes.value,
      encerramentoInscricoes.value,
      +nroVagas.value
    );
    try{
      this.limparDadosModal(unidadeSelecionada, inicioInscricoes, encerramentoInscricoes, nroVagas);
    }catch(ex){}
  }

  validaUnidade(unidadeSelecionada, nroVagas, inicioInscricoes, encerramentoInscricoes) {
    if (+nroVagas <= 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Número de vagas inválido' });
      return false;
    }

    if (unidadeSelecionada === '0') {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione alguma unidade' });
      return false;
    }

    if (inicioInscricoes === undefined || encerramentoInscricoes === undefined) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione ambas as datas' });
      return false;
    }

    if (encerramentoInscricoes < inicioInscricoes) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'A data do encerramento das inscrições não pode ser menor que a data de início das inscrições.'
      });
      return false;
    }

    return true;
  }

  limparDadosModal(unidadeSelecionada, inicioInscricoes, encerramentoInscricoes, nroVagas) {
    //console.log(unidadeSelecionada, inicioInscricoes, encerramentoInscricoes, nroVagas);
    this.display = false;

    unidadeSelecionada.selectedIndex = 0;
    unidadeSelecionada.disabled = false;
    inicioInscricoes.inputFieldValue = '';
    encerramentoInscricoes.inputFieldValue = '';
    nroVagas.value = '0';
  }

  adicionaOuEditaUnidade(idUnidade, nomeUnidade, inicioInscricoes, encerramentoInscricoes, nroVagas, idFaseUnidade = null) {
    const unidadeSelecionada = this.unidadesSelecionadas.controls.find(us => us.value.idUnidade === idUnidade);

    if (unidadeSelecionada == null) {
      const unidadeFormGroup = this.fb.group({
        idUnidade: idUnidade,
        nomeUnidade: nomeUnidade,
        inicioInscricoes: inicioInscricoes,
        encerramentoInscricoes: encerramentoInscricoes,
        nroVagas: +nroVagas,
        idFaseUnidade: idFaseUnidade
      });
      this.unidadesSelecionadas.push(unidadeFormGroup);
    } else {
      unidadeSelecionada.value.inicioInscricoes = inicioInscricoes;
      unidadeSelecionada.value.encerramentoInscricoes = encerramentoInscricoes;
      unidadeSelecionada.value.nroVagas = nroVagas;
    }

    this.recalcularNroVagasTotal();

    const unidade = this.unidades.find(u => u.idUnidade === idUnidade);
    this.unidadesCidade.push(unidade);
    this.unidadesCategoria.push(unidade);
    const index = this.unidades.indexOf(unidade);
    this.unidades.splice(index, 1);
  }

  abreEdicaoUnidadeSelecionada(
    unidade,
    unidadeSelecionada: HTMLSelectElement,
    inicioInscricoes,
    encerramentoInscricoes,
    nroVagas: HTMLInputElement
  ) {
    let abortar: boolean = false;
    this.cidadesSelecionadas.controls.forEach(cs => {
      if (cs.value.idUnidade == unidade.value.idUnidade) {
        abortar = true;
      }
    });
    if (abortar) return this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Unidade com vagas em uso' });

    this.display = true;

    const unidadeOption = new Option(unidade.value.nomeUnidade, unidade.value.idUnidade);
    unidadeSelecionada.add(unidadeOption);

    unidadeSelecionada.value = unidadeOption.value;
    unidadeSelecionada.disabled = true;

    const inidata = new Date(unidade.value.inicioInscricoes);
    inicioInscricoes.value = inidata;
    inicioInscricoes.inputFieldValue = inidata.getDate() + '/' + (inidata.getMonth() + 1) + '/' + inidata.getFullYear();

    const encdata = new Date(unidade.value.encerramentoInscricoes);
    encerramentoInscricoes.value = encdata;
    encerramentoInscricoes.inputFieldValue = encdata.getDate() + '/' + (encdata.getMonth() + 1) + '/' + encdata.getFullYear();

    nroVagas.value = unidade.value.nroVagas;
  }

  removeUnidadeSelecionada(unidade) {
    let abortar: boolean = false;
    this.cidadesSelecionadas.controls.forEach(cs => {
      if (cs.value.idUnidade == unidade.value.idUnidade) {
        abortar = true;
      }
    });
    if (abortar) return this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Unidade com vagas em uso' });

    const index = this.unidadesSelecionadas.controls.indexOf(unidade);
    this.unidadesSelecionadas.removeAt(index);

    this.recalcularNroVagasTotal();
  }
  // Unidade
  // ------

  recalcularNroVagasTotal() {
    let soma = 0;
    this.unidadesSelecionadas.controls.forEach(us =>
      soma = soma + us.value.nroVagas
    );
    this.nroVagasTotal.setValue(soma);
  }

  criarEditarFase() {
    if (!this.validaForm()) {
      return;
    }

    this.confirmationService.confirm({
      message: 'Deseja confirmar os dados digitados?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.removeArquivosDoBanco(this.arquivosToRemove.controls);

        this.isLoading = true;
        this.faseService.cadastrarEditarFase(this.form.value)
          .finally(() => this.isLoading = false)
          .subscribe(
            response => {
              localStorage.setItem('mensagem', 'Registro salvo com sucesso!');
              this.router.navigate(['/gerenciar-fase']);
            },
            error => this.gerenciaErro(error)
          );
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  // TODO isto pode ser um exit guard
  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        let arquivosNovos: AbstractControl[];
        arquivosNovos = this.arquivos.controls.filter(arquivo => !arquivo.value.isOld);
        arquivosNovos.concat(this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld));
        this.removeArquivosDoBanco(arquivosNovos);

        this.router.navigate(['/gerenciar-fase']);
      }
    });
  }

  validaForm(): boolean {
    if (this.arquivos.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Documento não inserido!' });
      return false;
    }

    if (this.unidadesSelecionadas.length <= 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'É necessário adicionar ao menos uma Unidade Operacional!'
      });
      return false;
    }

    if (this.form.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Formulário preenchido incorretamente.' });
      return false;
    }

    return true;
  }
  //Cidade
  mostrarDialogCidade(unidadeSelecionadaCid: HTMLSelectElement,cidadeSelecionada: HTMLSelectElement, numVagas: HTMLInputElement) {
    this.displayCidade = true;
    this.tituloCidade = 'Adicionar Cidade';
    this.cidades = this.cidadesModal;
    unidadeSelecionadaCid.selectedIndex = 0;
    unidadeSelecionadaCid.disabled = false;

    cidadeSelecionada.selectedIndex = 0;
    cidadeSelecionada.disabled = false;
    numVagas.value = '0';
    //console.log(categoriaSelecionada.options);
    try{
      for(var i=0; i<cidadeSelecionada.options.length; i++) {
        if (cidadeSelecionada.options[i].innerHTML == 'Primeira Habilitação') {cidadeSelecionada.options[i].remove()};
        if (cidadeSelecionada.options[i].innerHTML == 'Adição de Categoria A ou B') {cidadeSelecionada.options[i].remove()};
        if (cidadeSelecionada.options[i].innerHTML == 'Mudança de Categoria') {cidadeSelecionada.options[i].remove()};
      }
    }catch(e){}
  }
  enviaCidade(unidadeSelecionadaCid: HTMLSelectElement,cidadeSelecionada: HTMLSelectElement, numVagas: HTMLInputElement) {
    if (!this.validaCidade(cidadeSelecionada.value, numVagas.value)) {
      return;
    }
    this.adicionaOuEditaCidade(
      unidadeSelecionadaCid.value,
      unidadeSelecionadaCid[unidadeSelecionadaCid.selectedIndex].innerHTML,
      cidadeSelecionada.value,
      cidadeSelecionada[cidadeSelecionada.selectedIndex].innerHTML,
      +numVagas.value
    );
    try{
      this.limparDadosModalCidade(unidadeSelecionadaCid, cidadeSelecionada, numVagas);
    }catch(ex){}
  }
  adicionaOuEditaCidade(idUnidade, tituloUnidade, idMunicipio, nomeCidade, numVagas, idFaseUnidade = null) {
    let abortar = false;
    let totalVagasUnidade:number = 0;
    this.unidadesSelecionadas.controls.forEach(us => {
      if (us.value.idUnidade == idUnidade) {
        totalVagasUnidade = us.value.nroVagas;
      }
    });
    let totalVagasCidade:number = 0;
    const cidadeSelecionada = this.cidadesSelecionadas.controls.find(us => us.value.idMunicipio === idMunicipio && us.value.idUnidade === idUnidade);

    if (cidadeSelecionada == null) {
      this.cidadesSelecionadas.controls.forEach(cs => {
        if (cs.value.idUnidade == idUnidade) {
          totalVagasCidade = (totalVagasCidade + cs.value.numVagas);
        }
      });
      totalVagasCidade = totalVagasCidade + numVagas;
      abortar = (totalVagasCidade > totalVagasUnidade)
      if (abortar) return this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Número de vagas excede vagas da unidade' });

      const cidadeFormGroup = this.fb.group({
        idUnidade: idUnidade,
        tituloUnidade: tituloUnidade,
        idMunicipio: idMunicipio,
        nomeCidade: nomeCidade,
        numVagas: +numVagas,
        idFaseUnidade: idFaseUnidade
      });
      this.cidadesSelecionadas.push(cidadeFormGroup);
    } else {
      //validar edicao superior
      console.log('Pos Edicao U '+ totalVagasUnidade);
      let vagaDiff = 0
      vagaDiff = +numVagas - cidadeSelecionada.value.numVagas;
      console.log('Pos Edicao Diff ' + vagaDiff);
      let totalVagasCidade:number = 0;
      this.cidadesSelecionadas.controls.forEach(cs => {
        if (cs.value.idUnidade == idUnidade) {
          totalVagasCidade = (totalVagasCidade + cs.value.numVagas);
        }
      });
      totalVagasCidade = totalVagasCidade + vagaDiff;
      console.log('Pos Edicao ' + totalVagasCidade);
      abortar = (totalVagasCidade > totalVagasUnidade)
      if (abortar) {
        this.displayCidade = false;
        return this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Número de vagas excede vagas da unidade' });
      }
      cidadeSelecionada.value.numVagas = numVagas;
      this.displayCidade = false;
    }

    this.recalcularNroVagasTotalCidades();

    const cidade = this.cidadesModal.find(u => u.idMunicipio === idMunicipio);
    console.log(cidade);
    try {
      if(cidade) this.cidadesCategoria.push(cidade);
    }catch{}
    const index = this.cidadesModal.indexOf(cidade);
    //this.categorias.splice(index, 1);
  }
  abreEdicaoCidadeSelecionada(
    unidadeSelecionadaCid: HTMLSelectElement,
    cidade,
    cidadeSelecionada: HTMLSelectElement,
    numVagas: HTMLInputElement
  ) {
    let abortar: boolean = false;
    this.categoriasSelecionadas.controls.forEach(cs => {
      if (cs.value.idMunicipio == cidade.value.idMunicipio) {
        abortar = true;
      }
    });
    if (abortar) return this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Unidade com vagas em uso' });

    this.cidades = this.cidadesModal;

    this.displayCidade = true;
    this.tituloCidade = 'Editar Cidade';
    let isAddCid = true;
    try{
      for (var i = 0; i < (cidadeSelecionada.childNodes.length); i++) {
        if (cidadeSelecionada.options[i].value == cidade.value.idMunicipio){
          isAddCid = false;
          console.log(isAddCid);
        }
      }
    }catch(e){}
    const cidadeOption = new Option(cidade.value.nomeCidade, cidade.value.idMunicipio);
    if (isAddCid) cidadeSelecionada.add(cidadeOption);
    cidadeSelecionada.value = cidadeOption.value;
    cidadeSelecionada.disabled = true;

    let isAddUnid = true;
    try{
      for (var i = 0; i < (unidadeSelecionadaCid.childNodes.length); i++) {
        if (unidadeSelecionadaCid.options[i].value == cidade.value.idUnidade){
          isAddUnid = false;
          console.log(isAddUnid);
        }
      }
    }catch(e){}
    const unidadeCidOption = new Option(cidade.value.tituloUnidade, cidade.value.idUnidade);

    if (isAddUnid) unidadeSelecionadaCid.add(unidadeCidOption);

    unidadeSelecionadaCid.value = cidade.value.idUnidade;
    unidadeSelecionadaCid.disabled = true;

    numVagas.value = cidade.value.numVagas;
  }
  removeCidadeSelecionada(cidade) {
    let abortar: boolean = false;
    this.categoriasSelecionadas.controls.forEach(cs => {
      if (cs.value.idMunicipio == cidade.value.idMunicipio) {
        abortar = true;
      }
    });

    if (abortar) return this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Cidade com vagas em uso' });
    const index = this.cidadesSelecionadas.controls.indexOf(cidade);
    this.cidadesSelecionadas.removeAt(index);

    this.recalcularNroVagasTotalCidades();
  }
  recalcularNroVagasTotalCidades() {
    let soma = 0;
    this.cidadesSelecionadas.controls.forEach(us =>
      soma = soma + us.value.numVagas
    );
    this.nroVagasTotalCidades.setValue(soma);
  }
  limparDadosModalCidade(unidadeSelecionadaCid, cidadeSelecionada, numVagas) {
    this.displayCidade = false;

    unidadeSelecionadaCid.selectedIndex = 0;
    unidadeSelecionadaCid.disabled = false;

    cidadeSelecionada.selectedIndex = 0;
    cidadeSelecionada.disabled = false;
    numVagas.value = '0';
  }
  validaCidade(cidadeSelecionada, numVagas) {
    if (+numVagas <= 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Número de vagas inválido' });
      return false;
    }

    if (cidadeSelecionada === '0') {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione alguma cidade' });
      return false;
    }

    return true;
  }
  //Categoria
  mostrarDialogCategoria(unidadeSelecionadaCat: HTMLSelectElement,categoriaSelecionada: HTMLSelectElement, qtdVagas: HTMLInputElement) {
    this.displayCategoria = true;
    this.tituloCategoria = 'Adicionar Categoria';
    this.categorias = this.categoriasModal.filter((c) => {if(c.statusExclusao === false) return c;});
    unidadeSelecionadaCat.selectedIndex = 0;
    unidadeSelecionadaCat.disabled = false;

    categoriaSelecionada.selectedIndex = 0;
    categoriaSelecionada.disabled = false;
    qtdVagas.value = '0';
    //console.log(categoriaSelecionada.options);
    try{
      for(var i=0; i<categoriaSelecionada.options.length; i++) {
        if (categoriaSelecionada.options[i].innerHTML == 'Primeira Habilitação') {categoriaSelecionada.options[i].remove()};
        if (categoriaSelecionada.options[i].innerHTML == 'Adição de Categoria A ou B') {categoriaSelecionada.options[i].remove()};
        if (categoriaSelecionada.options[i].innerHTML == 'Mudança de Categoria') {categoriaSelecionada.options[i].remove()};
      }
    }catch(e){}
  }
  enviaCategoria(unidadeSelecionadaCat: HTMLSelectElement,cidadeSelecionadaCat: HTMLSelectElement,categoriaSelecionada: HTMLSelectElement, qtdVagas: HTMLInputElement) {
    if (!this.validaCategoria(categoriaSelecionada.value, qtdVagas.value)) {
      return;
    }
    this.adicionaOuEditaCategoria(
      unidadeSelecionadaCat.value,
      unidadeSelecionadaCat[unidadeSelecionadaCat.selectedIndex].innerHTML,
      cidadeSelecionadaCat.value,
      cidadeSelecionadaCat[cidadeSelecionadaCat.selectedIndex].innerHTML,
      categoriaSelecionada.value,
      categoriaSelecionada[categoriaSelecionada.selectedIndex].innerHTML,
      +qtdVagas.value
    );
    try{
      this.limparDadosModalCategoria(unidadeSelecionadaCat, cidadeSelecionadaCat, categoriaSelecionada, qtdVagas);
    }catch(ex){}
  }
  adicionaOuEditaCategoria(idUnidade, tituloUnidade, idMunicipio, nomeCidade, idIndicador, titulo, qtdVagas, idFaseUnidade = null) {
    let abortar = false;
    let totalVagasUnidade:number = 0;
    this.unidadesSelecionadas.controls.forEach(us => {
      if (us.value.idUnidade == idUnidade) {
        totalVagasUnidade = us.value.nroVagas;
      }
    });
    let totalVagasCidade:number = 0;
    this.cidadesSelecionadas.controls.forEach(us => {
      if (us.value.idMunicipio == idMunicipio) {
        totalVagasCidade = us.value.numVagas;
      }
    });
    console.log('Cidade '+ nomeCidade + ' - ' + totalVagasCidade);
    let totalVagasCategoria:number = 0;
    const categoriaSelecionada = this.categoriasSelecionadas.controls.find(us => us.value.idIndicador === idIndicador && us.value.idUnidade === idUnidade && us.value.idMunicipio == idMunicipio);

    if (categoriaSelecionada == null) {
      this.categoriasSelecionadas.controls.forEach(cs => {
        if (cs.value.idUnidade == idUnidade && cs.value.idMunicipio == idMunicipio) {
          totalVagasCategoria = (totalVagasCategoria + cs.value.qtdVagas);
        }
      });
      totalVagasCategoria = totalVagasCategoria + qtdVagas;
      abortar = (totalVagasCategoria > totalVagasCidade)
      if (abortar) return this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Número de vagas excede vagas da cidade' });

      const categoriaFormGroup = this.fb.group({
        idUnidade: idUnidade,
        tituloUnidade: tituloUnidade,
        idMunicipio: idMunicipio,
        nomeCidade: nomeCidade,
        idIndicador: idIndicador,
        titulo: titulo,
        qtdVagas: +qtdVagas,
        idFaseUnidade: idFaseUnidade
      });
      this.categoriasSelecionadas.push(categoriaFormGroup);
    } else {
      //validar edicao superior
      console.log('Pos Edicao U '+ totalVagasUnidade);
      let vagaDiff = 0
      vagaDiff = +qtdVagas - categoriaSelecionada.value.qtdVagas;
      console.log('Pos Edicao Diff ' + vagaDiff);
      let totalVagasCategoria:number = 0;
      this.categoriasSelecionadas.controls.forEach(cs => {
        if (cs.value.idUnidade == idUnidade) {
          totalVagasCategoria = (totalVagasCategoria + cs.value.qtdVagas);
        }
      });
      totalVagasCategoria = totalVagasCategoria + vagaDiff;
      console.log('Pos Edicao ' + totalVagasCategoria);
      abortar = (totalVagasCategoria > totalVagasUnidade)
      if (abortar) {
        this.displayCategoria = false;
        return this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Número de vagas excede vagas da unidade' });
      }
      categoriaSelecionada.value.qtdVagas = qtdVagas;
      this.displayCategoria = false;
    }

    this.recalcularNroVagasTotalCategorias();

    const categoria = this.categoriasModal.find(u => u.idIndicador === idIndicador);
    const index = this.categoriasModal.indexOf(categoria);
    //this.categorias.splice(index, 1);
  }
  abreEdicaoCategoriaSelecionada(
    unidadeSelecionadaCat: HTMLSelectElement,
    cidadeSelecionadaCat: HTMLSelectElement,
    categoria,
    categoriaSelecionada: HTMLSelectElement,
    qtdVagas: HTMLInputElement
  ) {
    this.categorias = this.categoriasModal;
    this.displayCategoria = true;
    this.tituloCategoria = 'Editar Categoria';
    //Categoria
    let isAddCat = true;
    try{
      for (var i = 0; i < (categoriaSelecionada.childNodes.length); i++) {
        if (categoriaSelecionada.options[i].value == categoria.value.idIndicador){
          isAddCat = false;
          console.log(isAddCat);
        }
      }
    }catch(e){}
    const categoriaOption = new Option(categoria.value.titulo, categoria.value.idIndicador);
    if (isAddCat) categoriaSelecionada.add(categoriaOption);
    categoriaSelecionada.value = categoriaOption.value;
    categoriaSelecionada.disabled = true;
    //Cidade
    let isAddCid = true;
    try{
      for (var i = 0; i < (cidadeSelecionadaCat.childNodes.length); i++) {
        if (cidadeSelecionadaCat.options[i].value == categoria.value.idMunicipio){
          isAddCid = false;
          console.log(isAddCid);
        }
      }
    }catch(e){}
    const cidadeOption = new Option(categoria.value.nomeCidade, categoria.value.idMunicipio);

    if (isAddCid) cidadeSelecionadaCat.add(cidadeOption);

    cidadeSelecionadaCat.value = categoria.value.idMunicipio;
    cidadeSelecionadaCat.disabled = true;
    //Unidade
    let isAddUnid = true;
    try{
      for (var i = 0; i < (unidadeSelecionadaCat.childNodes.length); i++) {
        if (unidadeSelecionadaCat.options[i].value == categoria.value.idUnidade){
          isAddUnid = false;
          console.log(isAddUnid);
        }
      }
    }catch(e){}
    const unidadeOption = new Option(categoria.value.tituloUnidade, categoria.value.idUnidade);

    if (isAddUnid) unidadeSelecionadaCat.add(unidadeOption);

    unidadeSelecionadaCat.value = categoria.value.idUnidade;
    unidadeSelecionadaCat.disabled = true;

    qtdVagas.value = categoria.value.qtdVagas;
  }
  removeCategoriaSelecionada(categoria) {
    const index = this.categoriasSelecionadas.controls.indexOf(categoria);
    this.categoriasSelecionadas.removeAt(index);

    this.recalcularNroVagasTotalCategorias();
  }
  recalcularNroVagasTotalCategorias() {
    let soma = 0;
    this.categoriasSelecionadas.controls.forEach(us =>
      soma = soma + us.value.qtdVagas
    );
    this.nroVagasTotalCategorias.setValue(soma);
  }
  limparDadosModalCategoria(unidadeSelecionadaCat, cidadeSelecionadaCat, categoriaSelecionada, qtdVagas) {
    this.displayCategoria = false;

    unidadeSelecionadaCat.selectedIndex = 0;
    unidadeSelecionadaCat.disabled = false;

    cidadeSelecionadaCat.selectedIndex = 0;
    cidadeSelecionadaCat.disabled = false;

    categoriaSelecionada.selectedIndex = 0;
    categoriaSelecionada.disabled = false;
    qtdVagas.value = '0';
  }
  validaCategoria(categoriaSelecionada, qtdVagas) {
    if (+qtdVagas <= 0) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Número de vagas inválido' });
      return false;
    }

    if (categoriaSelecionada === '0') {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione alguma categoria' });
      return false;
    }

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/fase/cadastrar-editar/cadastrar-editar-fase.component.ts